
import 'element-ui/lib/theme-chalk/index.css'

/* eslint-disable no-undef */
window.$ = window.jQuery = require('jquery')
require('bootstrap-sass')
require('sweetalert')



// WEBPACK FOOTER //
// ./src/includes.js